<template>
  <div
    class="s-select-dropdown"
    :class="[{ 'is-multiple': $parent.multiple }, popperClass]"
    data-app="true"
    :style="{ minWidth: minWidth }">
    <slot/>
  </div>
</template>

<script type="text/babel">
import Popper from '../../utils/vue-popper'

export default {
  name: 'selectDropdown',
  componentName: 'sSelectDropdown',
  mixins: [Popper],
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    boundariesPadding: {
      type: Number,
      default: 10
    },
    popperOptions: {
      type: Object,
      default() {
        return {
          gpuAcceleration: false,
        }
      }
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      minWidth: ''
    }
  },
  computed: {
    popperClass() {
      return this.$parent.popperClass
    },
    inputWidth() {
      return this.$parent?.inputWidth
    }
  },
  watch: {
    inputWidth() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 15 + 'px'
    }
  },
  mounted() {
    this.referenceElm = this.$parent.$refs.reference.$el
    this.$parent.popperElm = this.popperElm = this.$el
    this.$on('updatePopper', () => {
      if (this.$parent.visible) { this.updatePopper() }
    })
    this.$on('destroyPopper', this.destroyPopper)
  }
}
</script>